import i18n from '../i18n'
import GatherError from '../config/gatherErrorCode'
import md5 from './encrypt'
import { hasChinese, hasWest } from './language'
/**
 *
 * @param {*} name
 * @param {*} value
 * @param {*} hours
 * @param {*} domain
 * @param {*} path
 * cookie('author', 'seven') => set cookie
 * cookie('author') => get cookie
 * cookie('author', null) => delete cookie
 */
export const getCookie = function (keyName) {
  const name = `${keyName}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1)
    if (c.includes(name)) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const setCookie = function (name, value, day) {
  if (!day) day = 1
  const exp = new Date()
  exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000)
  let domain = ''
  if (__DEV__) {
    domain = location.hostname
  } else {
    domain = '.camcard.com'
  }
  document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()};domain=${domain};path=/;`
}

export const cookieEnable = function () {
  let result = false
  if (navigator.cookieEnabled) return true
  document.cookie = 'testcookie=yes;'
  const cookieSet = document.cookie
  if (cookieSet.includes('testcookie=yes')) {
    const exp = new Date()
    exp.setTime(exp.getTime() - 1)
    document.cookie = `testcookie` + `=` + `` + `; expires=${exp.toGMTString()}` // 删除测试cookie
    result = true
  }
  return result
}

/**
 * 根据地区获取map链接
 */
export const getMapUrl = function (address) {
  let map_url = ''
  if (!address || address.length == 0) {
    map_url = ''
  }
  if (address && typeof address === 'object') {
    if (address.country) {
      map_url += `${address.country} `
    }
    if (address.state) {
      map_url += `${address.state} `
    }
    if (address.city) {
      map_url += `${address.city} `
    }
    if (address.street1) {
      map_url += `${address.street1} `
    }
    if (address.street2) {
      map_url += address.street2
    }
  } else {
    map_url = address || ''
  }
  if (!map_url.trim()) return ''
  if (!map_url) return ''
  if (i18n.locale == 'zh-cn') {
    map_url = `http://api.map.baidu.com/geocoder?address=${encodeURIComponent(
      map_url.trim()
    )}&output=html&src=IntSig|CamCard`
  } else {
    map_url = `https://maps.google.com/maps?ie=UTF8&source=CamCard&q=${encodeURIComponent(
      map_url.trim()
    )}`
  }
  return map_url
}

export const xssHtml = function (value) {
  value = value && `${value}`.replace(/'/g, '&#39;')
  value = value && `${value}`.replace(/"/g, '&quot;')
  value = value && `${value}`.replace(/</g, '&lt;')
  value = value && `${value}`.replace(/>/g, '&gt;')
  return value
}

export const isChinese = function (value) {
  const reg = /[\u4E00-\u9FA5]/
  if (reg.test(value)) return true
  return false
}

export const isJapanese = function (value) {
  const reg = /[\u0800-\u4E00]/
  if (reg.test(value)) return true
  return false
}

export const isKoera = function (value) {
  if ((value > 0x3130 && value < 0x318f) || (value >= 0xac00 && value <= 0xd7a3)) {
    return true
  }
  return false
}
/**
 * 字符串是否有中日韩文
 * @param  value 字符串
 * @return bool 有中日韩文返回true
 */
export const checkStrLang = function (value) {
  if (Array.isArray(value)) {
    value = value.join('')
  }
  if (isChinese(value) || isJapanese(value) || isKoera(value)) {
    return true
  }
  return false
}

export const getBase64Image = function (img) {
  const canvas = document.createElement('canvas')
  canvas.width = img.width
  canvas.height = img.height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, img.width, img.height)
  const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
  const dataURL = canvas.toDataURL(`image/${ext}`)
  return dataURL
}

/**
 * 计算百分比
 * @param num
 * @param total 总数
 * @returns {int}
 */
export const percentage = function (num, total) {
  num = +num
  total = +total
  if (isNaN(num) || isNaN(total)) return 0
  num = parseInt(num)
  total = parseInt(total)
  if (total == 0) return 0
  return Math.floor((num / total) * 100)
}

/**
 * 将内容插入到光标处
 * @param {*} id
 * @param {*} content
 */
export const insertInputTxt = function (id, content) {
  const elInput = document.getElementById(id)
  const start = elInput.selectionStart
  const end = elInput.selectionEnd
  console.log(start, end)
  if (start === undefined || end === undefined) return
  const txt = elInput.value
  const result = txt.substring(0, start) + content + txt.substring(end)
  elInput.value = result
  elInput.focus()
  elInput.selectionStart = start + content.length
  elInput.selectionEnd = start + content.length
  return result
}

export const isEmptyObject = function (obj) {
  if (!obj) return true
  if (Object.keys(obj).length == 0) return true
  return false
}

export const calcPageData = function (list, page, size) {
  const start = (page - 1) * size
  const end = page * size > list.length ? list.length : page * size
  return list.slice(start, end)
}

/**
 * 去重
 */
export const unique = function (array) {
  const result = [...new Set(array)]
  return result
}

/**
 * 加载图片
 */
export const loadImage = function (src, cb) {
  const img = new Image()
  img.onreadystatechange = function () {
    if (this.readyState == 'complete') {
      cb({ w: img.width, h: img.height })
    }
  }
  img.onload = function () {
    if (this.complete == true) {
      cb({ w: img.width, h: img.height })
    }
  }
  img.onerror = function () {
    cb({ w: 0, h: 0 })
  }
  img.src = src
}

/**
 * 二次加密密码
 * @param {string|number} s
 * @param {string|number} d
 * @returns
 */
export const encryptionPassword = function (s, d) {
  const PASSWORD_SUFFIX = '_IntSig'
  let tempString = null
  tempString = md5.md5(`${s}${PASSWORD_SUFFIX}`)
  tempString = md5.md5(`${tempString.substr(0, tempString.length / 2)}_${d}`)
  return tempString.substr(0, tempString.length / 2)
}

/**
 * 加密密码
 * @param {string|number} s
 * @param {string|number} d
 * @returns
 */
export const encryptionPassword16 = function (s) {
  const PASSWORD_SUFFIX = '_IntSig'
  let tempString = null
  tempString = md5.md5(`${s}${PASSWORD_SUFFIX}`)
  tempString.substr(0, tempString.length / 2)
  return tempString
}

/**
 * 格式化时间戳
 * @param {*} s
 * @returns
 */
export const formatTimeTemp = function (s, showYear) {
  const date = new Date(s)
  const year = date.getFullYear()
  const mouth = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
  const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`
  const min = date.getMinutes() >= 10 ? date.getMinutes() : `0${date.getMinutes()}`
  return `${showYear ? `${year}-` : ''}${mouth}-${day} ${date.getHours()}:${min}`
}

/**
 * 格式化文件大小
 * @param {*} bytes
 * @param {*} t
 */
export const formatFileSize = function (bytes) {
  const unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let index = 0
  let srcsize
  let size
  if (bytes == null || bytes === '') return '0'
  srcsize = parseFloat(bytes)
  index = Math.floor(Math.log(srcsize) / Math.log(1024))
  size = srcsize / 1024 ** index
  if (srcsize < 1 * 1024 * 1024) {
    size = size.toFixed(0)
  } else {
    size = size.toFixed(2)
  }
  return [Number(size), unitArr[index]]
}

/**
 * 格式化错误提示
 * @param {Object} e
 * @param {String} t
 */
export const formatErrorTxt = function (e, t) {
  if (!e || !e.errno) return GatherError[t][1]
  return GatherError[t][e.errno]
}

/**
 * 转换文件
 * @param {*} data
 * @param {*} type
 * @param {*} name
 */
export const convertBlobFile = function (data, type, name) {
  const MIMES = {
    html: 'text/html',
    txt: 'text/plain;charset=utf-8',
    doc: 'application/msword',
    xlsx: 'application/vnd.ms-excel;charset=utf-8'
  }
  let blob = null
  try {
    blob = new Blob([data], {
      type: MIMES.type
    })
  } catch (e) {
    blob = new Blob(data, {
      type: MIMES.type
    })
  }
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, `${name}.${type}`)
  } else {
    if (navigator.userAgent.includes('Firefox')) {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.setAttribute('id', 'saveFilesData')
      a.setAttribute('download', 'excel.xlsx')
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = `${name}.${type}`
      a.click()
      window.URL.revokeObjectURL(url)
    } else {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      a.setAttribute('id', 'saveFilesData')
      a.setAttribute('download', 'excel.xlsx')
      // 防止反复添加
      if (document.getElementById('saveFilesData'))
        document.body.removeChild(document.getElementById('saveFilesData'))
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = `${name}.${type}`
      a.click()
      window.URL.revokeObjectURL(url)
    }
  }
}

/**
 * 导出excel 模板
 * @param {*} filecontent
 * @param {*} filename
 */
export const exportExcel = function (filecontent, filename) {
  const sliceSize = 512
  const byteCharacters = window.atob(filecontent)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)
    const byteNumbers = new Array(slice.length)

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: 'application/vnd.ms-excel' })
  // 下载：
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.download = filename // filename for example: `batch_add_ccvip_template.xlsx`
  link.href = url
  link.click()
}

export const blobify = function (strData) {
  const buf = new ArrayBuffer(strData.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i != strData.length; ++i) view[i] = strData.charCodeAt(i) & 0xff
  return buf
}

/*
 * 返回上一个路由
 */
export const backPage = function ($router) {
  if (window.history.length > 1) {
    $router.go(-1)
  } else {
    const userAgent = navigator.userAgent
    if (userAgent.includes('Firefox') || userAgent.includes('Chrome')) {
      window.location.href = 'about:blank'
      window.close()
    } else {
      window.opener = null
      window.open('', '_self')
      window.close()
    }
  }
}

export const generateNameDetail = function (username = '') {
  username = username.replace(/\s+/gi, ' ')
  const compound_surname = [
    '百里',
    '北堂',
    '北野',
    '淳于',
    '成公',
    '陈生',
    '端木',
    '东方',
    '东郭',
    '东野',
    '东门',
    '第二',
    '第五',
    '大狐',
    '公孙',
    '公冶',
    '公羊',
    '公良',
    '公西',
    '公孟',
    '高堂',
    '高阳',
    '皇甫',
    '夹谷',
    '敬花',
    '梁丘',
    '令狐',
    '闾丘',
    '洛阳',
    '陵尹',
    '冷富',
    '南宫',
    '南郭',
    '女娲',
    '欧阳',
    '濮阳',
    '青阳',
    '漆雕',
    '亓官',
    '壤驷',
    '上官',
    '少室',
    '少叔',
    '司徒',
    '司马',
    '司迁',
    '司空',
    '司寇',
    '士孙',
    '申屠',
    '澹台',
    '太史',
    '太叔',
    '太公',
    '闻人',
    '巫马',
    '微生',
    '王孙',
    '夏侯',
    '西门',
    '歆颖',
    '鲜于',
    '轩辕',
    '相里',
    '乐正',
    '羊舌',
    '羊角',
    '延陵',
    '诸葛',
    '颛孙',
    '仲孙',
    '仲长',
    '钟离',
    '宗政',
    '主父',
    '常夏',
    '陈梁',
    '陈林',
    '曹岳',
    '邓李',
    '范姜',
    '郭罗',
    '高陈',
    '胡杨',
    '黄方',
    '刘付',
    '刘谭',
    '陆费',
    '陆叶',
    '钱王',
    '钱赖',
    '巫许',
    '吴刘',
    '吴沈',
    '有琴',
    '张包',
    '张简',
    '钟任',
    '章项',
    '单于',
    '叱干',
    '叱利',
    '独孤',
    '赫连',
    '呼延',
    '贺兰',
    '夹谷',
    '吉胡',
    '敬花',
    '慕容',
    '万俟',
    '纳兰',
    '拓跋',
    '秃发',
    '完颜',
    '宇文',
    '尉迟',
    '长孙'
  ]
  let first_name = ''
  let last_name = ''
  if (username) {
    if (hasChinese(username)) {
      if (username.indexOf(' ') > 0) {
        const split_name = username.split(' ')
        // 判断是否有中间名
        if (split_name.length > 1) {
          if (hasWest(username)) {
            last_name = split_name[split_name.length - 1].trim()
            split_name.pop()
            if (split_name.length) {
              first_name = split_name.join(' ')
            }
          } else {
            last_name = split_name[0].trim()
            split_name.shift()
            if (split_name.length) {
              first_name = split_name.join(' ')
            }
          }
        }
      } else if (hasWest(username)) {
        // 中英混合无分隔符
        last_name = username.trim()
      } else {
        // 纯中文无分割符
        let is_compound = false
        if (username.length >= 2 && username.slice(0, 2)) {
          // if($.inArray(username.slice(0,2), compound_surname) >= 0){
          if (compound_surname.includes(username.slice(0, 2))) {
            is_compound = true
          }
        }
        last_name = username.slice(0, is_compound ? 2 : 1)
        first_name = username.slice(is_compound ? 2 : 1)
      }
    } else if (hasWest(username)) {
      // 纯英文
      const split_name = username.split(' ')
      if (split_name.length == 1) {
        last_name = split_name[0].trim()
      }
      // 判断是否有中间名
      if (split_name.length > 1) {
        last_name = split_name[split_name.length - 1].trim()
        split_name.pop()
        if (split_name.length) {
          first_name = split_name.join(' ')
        }
      }
    } else {
      last_name = username.substr(0, 1)
      first_name = username.substr(1)
    }
  }
  return {
    first_name,
    last_name
  }
}

/**
 * 检测是否为excel文件
 */
export const IsExcelFile = function (file) {
  const type = file.type
  return (
    type.includes('sheet') ||
    type.includes('xls') ||
    type.includes('xlsx') ||
    type.includes('excel')
  )
}
/**
 * object: 对象
 * path: 输入的路径
 * defaultVal: 默认值
 **/

function _get(object, path, defaultVal = 'undefined') {
  // 先将path处理成统一格式
  let newPath = []
  if (Array.isArray(path)) {
    newPath = path
  } else {
    // 先将字符串中的'['、']'去除替换为'.'，split分割成数组形式
    newPath = path.replace(/\[/g, '.').replace(/\]/g, '').split('.')
  }

  // 递归处理，返回最后结果
  return (
    newPath.reduce((o, k) => {
      console.log(o, k) // 此处o初始值为下边传入的 object，后续值为每次取的内部值
      return (o || {})[k]
    }, object) || defaultVal
  )
}
/**
 * @description: 获取LastPageId
 * @param {type} route 当前路由
 * @return: LastPageId
 */
export const getLastPageId = function (route) {
  const lastPageId = _get(route, 'meta.onePage') ? _get(route, 'meta.name') : route.name
  return lastPageId || ''
}

/**
 * 前端自定义日志上报
 * @param {*} operateMsg 操作信息
 * @param {*} err 错误信息
 */
export const operateLog = function (operateMsg, err = '') {
  // 记录用户操作行为，方便排查问题
  let str = ''
  try {
    if (Object.prototype.toString.call(err) === '[object Object]') {
      str = JSON.stringify(err || {})
    } else {
      str = `${err || 'nothing'}`
    }
    window.fLog &&
      window.fLog.log(
        operateMsg,
        str.substring(0, 400),
        str.substring(400),
        `lang:${i18n.locale} | ${navigator?.language}`
      )
  } catch (error) {}
}

/**
 * js 实现jq offset()
 * 取消jq依赖
 */

export const offset = function (node) {
  let offest = {
    top: 0,
    left: 0
  }
  // 当前为IE11以下, 直接返回{top: 0, left: 0}
  if (!node || typeof node.getClientRects !== 'function' || !node.getClientRects().length) {
    return offest
  }
  // 当前DOM节点的 display === 'node' 时, 直接返回{top: 0, left: 0}
  if (window.getComputedStyle(node).display === 'none') {
    return offest
  }
  // Element.getBoundingClientRect()方法返回元素的大小及其相对于视口的位置。
  // 返回值包含了一组用于描述边框的只读属性——left、top、right和bottom，单位为像素。除了 width 和 height 外的属性都是相对于视口的左上角位置而言的。
  // 返回如{top: 8, right: 1432, bottom: 548, left: 8, width: 1424…}
  offest = node.getBoundingClientRect()
  const docElement = node.ownerDocument.documentElement
  return {
    top: offest.top + window.pageYOffset - docElement.clientTop,
    left: offest.left + window.pageXOffset - docElement.clientLeft
  }
}

// 统一跳转域名
export const locationDomain = () => {
  const location = window.location
  const { href, hostname } = location
  // const hostname = 'https://bc104.camcard.com/card/view?first=1'
  let currentUrl = window.location.href

  if (__PRE__) {
    // 统一跳转b12013,目的是统一使用一个域名
    if (hostname.includes('bc104.camcard.com') || hostname.includes('bc102.camcard.com')) {
      currentUrl = href.replace('bc104.camcard.com', 'b12013.camcard.com')
      currentUrl = currentUrl.replace('bc102.camcard.com', 'b12013.camcard.com')
      location.href = currentUrl
    }
  } else if (__ONLINE__) {
    if (hostname.includes('b104.camcard.com') || hostname.includes('b102.camcard.com')) {
      // 兼容名片夹、工具箱、管理模块国内先上，国外不上的情况，除以下这些模块之外的页面不允许停留在 b102 和 b104
      const preName = location.pathname.split('/')[1]
      if (preName !== 'card' && preName !== 'tool' && preName !== 'admin' && preName !== 'crm') {
        currentUrl = href.replace('b104.camcard.com', 'b.camcard.com')
        currentUrl = currentUrl.replace('b102.camcard.com', 'b.camcard.com')
        console.log('currentUrl', currentUrl)
        location.href = currentUrl
      }
    }
  }
}
